<mat-form-field appearance="outline" class="col-md-12 col-sm-12 col-xs-12">
    <mat-label>Search</mat-label>
    <input matInput (keyup)="applyFilter($event)" placeholder="Search..." #input>
    <mat-icon matSuffix>search</mat-icon>
</mat-form-field>

<div style="overflow: auto;">
    <table mat-table #matTable [dataSource]="dataSource" matSort>

        <!-- Action Column -->
        <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef>Select</th>
            <td mat-cell *matCellDef="let row" (click)="selectPid(row)">
                <mat-icon style="cursor: pointer;">check_circle_outline</mat-icon>
            </td>
        </ng-container>

        <ng-container matColumnDef="permanent_id">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                Institute Permanent Id
            </th>
            <td mat-cell *matCellDef="let row"> {{row?.PERMANENT_ID}} </td>
        </ng-container>

        <ng-container matColumnDef="institute_name">
            <th mat-header-cell *matHeaderCellDef>
                Institute Name</th>
            <td mat-cell *matCellDef="let row"> {{row?.CURRENT_INSTITUTE_NAME}} </td>
        </ng-container>

        <ng-container matColumnDef="institute_state">
            <th mat-header-cell *matHeaderCellDef>
                Institute State</th>
            <td mat-cell *matCellDef="let row"> {{row?.INSTI_STATE}} </td>
        </ng-container>

        <ng-container matColumnDef="institute_add">
            <th mat-header-cell *matHeaderCellDef>
                Institute Address</th>
            <td mat-cell *matCellDef="let row"> {{row?.CURRENT_INSTITUTE_ADDRESS}} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;">
        </tr>
    </table>

    <div *ngIf="dataSource.data.length === 0">
        <br>
        <br>
        <p class="no-records-found"> No Records Found! </p>
    </div>
</div>
<mat-paginator fixed [pageSizeOptions]="[5, 10, 25, 50]" showFirstLastButtons>
</mat-paginator>